import React from 'react'
import Ad   from './Ad'

const LongStripAd = ({
  edition = {},
  type = '',
  adblock=false
}) => {

  let details = []
  let excludeVal1 = [ 's' ]
  let excludeVal2 = [ 's', 'm' ]
  
  if(edition.isAsiaRegion) {
    details.push(
      <div key="LongStripAd" className="ad-double-longstrip-wrapper">
        <div key="longstrip1" className="ad-double-longstrip">
          <Ad className="react-ad ad-slot-longstrip ad-wrapper" slotType="longstripGamepackage" kvpos="left" exclude={excludeVal1} isAdBlock={adblock}/>
        </div>
        { type === 'game' &&
          <div key="longstrip2" className="ad-double-longstrip">
            <Ad className="react-ad ad-slot-longstrip ad-wrapper" slotType="longstripGamepackage" kvpos="right" exclude={excludeVal2} isAdBlock={adblock}/>
          </div>
        }
      </div>
    )
  }

  return (
    <div>
    { details }
    </div>
  )
}

export default LongStripAd



// WEBPACK FOOTER //
// ../app/components/common/LongStripAd.jsx